import { render, staticRenderFns } from "./cModalStoreDispatchAct.vue?vue&type=template&id=5f98be37&scoped=true&lang=es"
import script from "./cModalStoreDispatchAct.vue?vue&type=script&lang=js"
export * from "./cModalStoreDispatchAct.vue?vue&type=script&lang=js"
import style0 from "./cModalStoreDispatchAct.vue?vue&type=style&index=0&id=5f98be37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f98be37",
  null
  
)

export default component.exports